const ArrowDown = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 2V30"
        stroke="#161616"
        style={{ stroke: "var(--svg-color)" }}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M25 21L16 30L7 21"
        stroke="#161616"
        style={{ stroke: "var(--svg-color)" }}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default ArrowDown;
